import { useTranslation } from 'react-i18next';
import { POOL_STATUS } from 'src/DTO/PoolStatus.enum';
import { Labels } from './useLabels.types';
import { PostFrequency, PostType } from 'src/DTO/FacebookPost.type';
import { getStatusLabel } from 'src/utils/getStatusLabel';
import { PostScheduleStatus } from 'src/pages/Facebook/components/types';

export const useLabels = () => {
  const { t } = useTranslation();

  const statusLabels: Labels<POOL_STATUS> = {
    [POOL_STATUS.NEW_APPLICATION]: t('workersPage.status.newApplication'),
    [POOL_STATUS.PENDING_OFFER]: t('workersPage.status.pendingOffer'),
    [POOL_STATUS.ACTIVE]: t('workersPage.status.active'),
    [POOL_STATUS.INACTIVE]: t('workersPage.status.inActive'),
    [POOL_STATUS.WORKER_UNDER_REVIW]: t('workersPage.status.underReview'),
  };

  const frequencyLabels: Labels<PostFrequency> = {
    [PostFrequency.DAILY]: 'Naponta',
    [PostFrequency.EVERY_SECOND_DAY]: 'Kétnaponta',
    [PostFrequency.WEEKLY]: 'Hetente',
  };

  const postTypeLabels: Labels<PostType> = {
    [PostType.POST]: 'Posztolás',
    [PostType.SHARE]: 'Megosztás',
  };

  const postScheduleStatusLabels: Labels<PostScheduleStatus> = {
    [PostScheduleStatus.ACTIVE]: 'Aktív',
    [PostScheduleStatus.INACTIVE]: 'Inaktív',
  };

  const handleFrequencyLabels = (value: PostFrequency): string => {
    return getStatusLabel(value, frequencyLabels);
  };

  const handlePostTypeLabels = (value: PostType): string => {
    return getStatusLabel(value, postTypeLabels);
  };

  const handlePostScheduleStatusLabels = (value: PostScheduleStatus): string => {
    return getStatusLabel(value, postScheduleStatusLabels);
  };

  return {
    statusLabels,
    frequencyLabels,
    postTypeLabels,
    handleFrequencyLabels,
    handlePostTypeLabels,
    handlePostScheduleStatusLabels,
  };
};
